import { KhronosAuth } from "../../platform/native";
import { getGoogleClientId } from "../../services/googleOAuth";

/**
 * Google sign-in inside the Android app. Google refuses its web sign-in in an
 * app's WebView (the pop-up), and the redirect flow would finish in Chrome
 * rather than the app, so the phone's account picker supplies the ID token
 * that POST /api/auth/google already accepts. Every sign-in entry point uses
 * this when isNativeApp().
 *
 * @param {{ login: (idToken: string) => Promise<unknown>, toast: { showToast: Function } }} deps
 */
export async function signInNatively({ login, toast }) {
  let idToken;
  try {
    ({ idToken } = await KhronosAuth.signInWithGoogle({
      serverClientId: getGoogleClientId(),
    }));
  } catch (err) {
    if (err?.code === "CANCELLED") return;
    console.error("Native Google sign-in failed:", err);
    toast.showToast({
      title: "Google sign-in failed",
      description: err?.message || "Google could not complete sign-in.",
      duration: 7000,
    });
    return;
  }
  // login() reports its own failures.
  await login(idToken).catch(() => {});
}
